import { createFileRoute } from '@tanstack/react-router';
import { DashboardStats } from '../../features/stats/dashboard-stats';

export const Route = createFileRoute('/_auth/dashboard')({
  component: DashboardStats,
});
